import React from "react";
import "../template-file-css/document-file-template.css";

export const NBT_ParentGuardian = ({ itemsRef, showErrorFor }) => {

   return (
      <form id='NBT_ParentGuardian' className='file-pdf-document'>
         <div className='file-template'>

            <h3>DSM-5 Parent/Guardian-Rated Level 1 Cross-Cutting Symptom Measure-Child Age 6-17</h3>
            <table>
               <tr>
                  <td className="w-250">
                     <span className="eleHeader">Child's Name:</span>
                     <input type="text" id="txtChild" name="txtChild" className="add-only" />
                  </td>
                  <td className="w-250">
                     <span className="eleHeader">Age:</span>
                     <input type="text" id="txtAge" name="txtAge" className="add-only" />
                  </td>
                  <td className="w-250">
                     <span className="eleHeader">Sex:</span>
                     <td className="w-100"><input type="radio" id="rbPregnancy_Yes" name="rbPregnancy" className="add-only" value=" &nbsp; 1- " />Male</td>
                     <td className="w-100"> <input type="radio" id="rbPregnancy_No" name="rbPregnancy" className="add-only" value="&nbsp; 0- " />Female</td>

                  </td>
               </tr>

               <tr>
                  <td className="w-250">
                     <span className="eleHeader">Date:</span>

                     <input type="date" id="txtDate" name="txtDate" className="add-only" />
                  </td>
                  <td className="w-250">
                     <span className="eleHeader">Relationship with the child:</span>
                     <input type="text" id="txtRelationship" name="txtRelationship" className="add-only" />

                  </td>
                  <td className="w-250">
                     &nbsp;
                  </td>
               </tr>
            </table>
            <p>
               <strong>Instructions</strong> (to the parent or guardian of child):The questions below ask about things that might have bothered your child. For each
               question, circle the number that best describes how much (or how often) your child has been bothered by each problem during the
               past TWO (2) WEEKS.
            </p>
            <p>
               During the past <strong>TWO (2) WEEKS,</strong> how much (or how often) have you...
            </p>
            <h3>I.</h3>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">1. Complained of stomachaches, headaches, or other aches and pains?</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None" name="rb_Stomachaches" className="add-only" value="None" />&nbsp; 0-None (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight" name="rb_Stomachaches" className="add-only" value="None" />&nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild" name="rb_Stomachaches" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate" name="rb_Stomachaches" className="add-only" value="None" />&nbsp; 3-Moderate (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe" name="rb_Stomachaches" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain" id="txtHighestDomain" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">2. Said he/she was worried about his/her health or about getting sick?</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None1" name="rb_GettingSick" className="add-only" value="None" />&nbsp; 0-None (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight1" name="rb_GettingSick" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild1" name="rb_GettingSick" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate1" name="rb_GettingSick" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe1" name="rb_GettingSick" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain1" id="txtHighestDomain1" className="add-only" />
                  </td>
               </tr>
            </table>
            <h3>II.</h3>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        3. Had problems sleeping-that is, trouble falling asleep, staying asleep, or
                        waking up too early?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None2" name="rb_FallAsleep" className="add-only" value="None" />&nbsp; 0-None (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight2" name="rb_FallAsleep" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild2" name="rb_FallAsleep" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate2" name="rb_FallAsleep" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe2" name="rb_FallAsleep" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain2" id="txtHighestDomain2" className="add-only" />
                  </td>
               </tr>
            </table>
            <h3>III.</h3>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        4. Had problems paying attention when he/she was in class or doing his/her
                        homework or reading a book or playing a game?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None3" name="rb_DoingHomework" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight3" name="rb_DoingHomework" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild3" name="rb_DoingHomework" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate3" name="rb_DoingHomework" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe3" name="rb_DoingHomework" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain3" id="txtHighestDomain3" className="add-only" />
                  </td>
               </tr>
            </table>
            <h3>IV.</h3>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">5 Had less fun doing things than he/she used to?</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None4" name="rb_FunDoingThings" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight4" name="rb_FunDoingThings" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild4" name="rb_FunDoingThings" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate4" name="rb_FunDoingThings" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe4" name="rb_FunDoingThings" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain4" id="txtHighestDomain4" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">6.Seemed sad or depressed for several hours?</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None5" name="rb_Depressed" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight5" name="rb_Depressed" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild5" name="rb_Depressed" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate5" name="rb_Depressed" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe5" name="rb_Depressed" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain5" id="txtHighestDomain5" className="add-only" />
                  </td>
               </tr>
            </table>
            <h3>
               V. & VI.
            </h3>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">7. Seemed more irritated or easily annoyed than usual?</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None6" name="rb_EasilyAnnoyed" className="add-only" value="None" />&nbsp; 0-None (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight6" name="rb_EasilyAnnoyed" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild6" name="rb_EasilyAnnoyed" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate6" name="rb_EasilyAnnoyed" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe6" name="rb_EasilyAnnoyed" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain6" id="txtHighestDomain6" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">8. Seemed angry or lost his/her temper?</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None7" name="rb_FeltAngry" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight7" name="rb_FeltAngry" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild7" name="rb_FeltAngry" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate7" name="rb_FeltAngry" className="add-only" value="None" />&nbsp; 3-Moderate (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe7" name="rb_FeltAngry" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain7" id="txtHighestDomain7" className="add-only" />
                  </td>
               </tr>
            </table>
            <h3>
               VII.
            </h3>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">9. Started lots more projects than usual or did more risky things than usual?</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None61" name="rb_EasilyAnnoyed1" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight61" name="rb_EasilyAnnoyed1" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild61" name="rb_EasilyAnnoyed1" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate61" name="rb_EasilyAnnoyed1" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe61" name="rb_EasilyAnnoyed1" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain61" id="txtHighestDomain61" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">10. Slept less than usual for him/her, but still had lots of energy?</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None71" name="rb_FeltAngry1" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight71" name="rb_FeltAngry1" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild71" name="rb_FeltAngry1" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate71" name="rb_FeltAngry1" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe71" name="rb_FeltAngry1" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain71" id="txtHighestDomain71" className="add-only" />
                  </td>
               </tr>
            </table>
            <h3>VIII.</h3>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">11. Said he/she felt nervous, anxious, or scared?</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None8" name="rb_FeltNervous" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight8" name="rb_FeltNervous" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild8" name="rb_FeltNervous" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate8" name="rb_FeltNervous" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe8" name="rb_FeltNervous" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain8" id="txtHighestDomain8" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">12. Not been able to stop worrying?</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None9" name="rb_StopWorrying" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight9" name="rb_StopWorrying" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild9" name="rb_StopWorrying" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate9" name="rb_StopWorrying" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe9" name="rb_StopWorrying" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain9" id="txtHighestDomain9" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        13. Said he/she couldn't do things he/she wanted to or should have done,
                        because they made him/her feel nervous?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None10" name="rb_FeelNervous" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight10" name="rb_FeelNervous" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild10" name="rb_FeelNervous" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate10" name="rb_FeelNervous" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe10" name="rb_FeelNervous" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain10" id="txtHighestDomain10" className="add-only" />
                  </td>
               </tr>
            </table>
            <h3>IX.</h3>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        14.
                        Said that he/she heard voices-when there was no one there-speaking
                        about him/her or telling him/her what to do or saying bad things to him/her?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None11" name="rb_HeardVoices" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight11" name="rb_HeardVoices" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild11" name="rb_HeardVoices" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate11" name="rb_HeardVoices" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe11" name="rb_HeardVoices" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain11" id="txtHighestDomain11" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        15.
                        Said that he/she had a vision when he/she was completely awake-that is,
                        saw something or someone that no one else could see?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None12" name="rb_Visions" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight12" name="rb_Visions" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild12" name="rb_Visions" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate12" name="rb_Visions" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe12" name="rb_Visions" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain12" id="txtHighestDomain12" className="add-only" />
                  </td>
               </tr>
            </table>
            <h3>X.</h3>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        16.
                        Said that he/she had thoughts that kept coming into his/her mind that he/she
                        would do something bad or that something bad would happen to him/her or to someone else?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None13" name="rb_SomethingBad" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight13" name="rb_SomethingBad" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild13" name="rb_SomethingBad" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate13" name="rb_SomethingBad" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe13" name="rb_SomethingBad" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain13" id="txtHighestDomain13" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        17.
                        Said he/she felt the need to check on certain things over and over again, like
                        whether a door was locked or whether the stove was turned off?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None14" name="rb_CertainThings" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight14" name="rb_CertainThings" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild14" name="rb_CertainThings" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate14" name="rb_CertainThings" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe14" name="rb_CertainThings" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain14" id="txtHighestDomain14" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        18.
                        Seemed to worry a lot about things he/she touched being dirty or having
                        germs or being poisoned?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None15" name="rb_BeingPoisoned" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight15" name="rb_BeingPoisoned" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild15" name="rb_BeingPoisoned" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate15" name="rb_BeingPoisoned" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe15" name="rb_BeingPoisoned" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain15" id="txtHighestDomain15" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        19.
                        Said that he/she had to do things in a certain way, like counting or saying
                        special things out loud, in order to keep something bad from happening?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_None16" name="rb_SpecialThings" className="add-only" value="None" />&nbsp; 0-None  (Not at all)
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Slight16" name="rb_SpecialThings" className="add-only" value="None" /> &nbsp; 1-Slight (Rare, less than a day or two)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Mild16" name="rb_SpecialThings" className="add-only" value="None" />&nbsp; 2-Mild (Several Days
                  </td>
                  <td className="w-375">
                     <input type="radio" id="rb_Moderate16" name="rb_SpecialThings" className="add-only" value="None" />&nbsp; 3-Moderate  (More than half the days)
                  </td>
               </tr>
               <tr>
                  <td className="w-375">
                     <input type="radio" id="rb_Severe16" name="rb_SpecialThings" className="add-only" value="None" />&nbsp; 4-Severe (Nearly every day)
                  </td>
                  <td className="w-375">&nbsp;</td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain16" id="txtHighestDomain16" className="add-only" />
                  </td>
               </tr>
            </table>
            <tr>
               <td className="w-750">
                  In the past TWO (2) WEEKS, has your child...
               </td>
            </tr>
            <h3>XI.</h3>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        20. Had an alcoholic beverage (beer, wine, liquor, etc.)?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-100">
                     <input type="radio" id="rb_Yes" name="rb_AlcoholicBeverage" className="add-only" value="Yes" />&nbsp; Yes
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_No" name="rb_AlcoholicBeverage" className="add-only" value="No" />&nbsp; No
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_Noi" name="rb_AlcoholicBeverage" className="add-only" value="No" />&nbsp; Don't Know
                  </td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain55" id="txtHighestDomain55" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        21. Smoked a cigarette, a cigar, or pipe, or used snuff or chewing tobacco?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-100">
                     <input type="radio" id="rb_Yes1" name="rb_Cigarette" className="add-only" value="Yes" />&nbsp; Yes
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_No1" name="rb_Cigarette" className="add-only" value="No" />&nbsp; No
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_Noi1" name="rb_Cigarette" className="add-only" value="No" />&nbsp; Don't Know
                  </td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain56" id="txtHighestDomain56" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        22. Used drugs like marijuana, cocaine or crack, club drugs (like ecstasy),
                        hallucinogens (like LSD), heroin, inhalants or solvents (like glue), or
                        methamphetamine (like speed)?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-100">
                     <input type="radio" id="rb_Yes22" name="rb_ClubDrugs2" className="add-only" value="Yes" />&nbsp; Yes
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_No22" name="rb_ClubDrugs2" className="add-only" value="No" />&nbsp; No
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_Noi22" name="rb_ClubDrugs2" className="add-only" value="No" />&nbsp; Don't Know
                  </td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain571" id="txtHighestDomain571" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        23. Used any medicine without a doctor's prescription (e.g., painkillers [like
                        Vicodin], stimulants [like Ritalin or Adderall], sedatives or tranquilizers [like
                        sleeping pills or Valium], or steroids)?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-100">
                     <input type="radio" id="rb_Yes2" name="rb_ClubDrugs" className="add-only" value="Yes" />&nbsp; Yes
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_No2" name="rb_ClubDrugs" className="add-only" value="No" />&nbsp; No
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_Noi2" name="rb_ClubDrugs" className="add-only" value="No" />&nbsp; Don't Know
                  </td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain57" id="txtHighestDomain57" className="add-only" />
                  </td>
               </tr>
            </table>
            <h3>XII.</h3>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        24.
                        In the past TWO (2) WEEKS, has he/she talked about wanting to kill
                        himself/herself or about wanting to commit suicide?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-100">
                     <input type="radio" id="rb_Yes4" name="rb_CommittingSuicide" className="add-only" value="Yes" />&nbsp; Yes
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_No4" name="rb_CommittingSuicide" className="add-only" value="No" />&nbsp; No
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_Noi4" name="rb_CommittingSuicide" className="add-only" value="No" />&nbsp; Don't Know
                  </td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain58" id="txtHighestDomain58" className="add-only" />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className="w-750">
                     <span className="eleHeader">
                        25. Has he/she EVER tried to kill himself/herself?
                     </span>
                  </td>
               </tr>
               <tr>
                  <td className="w-100">
                     <input type="radio" id="rb_Yes5" name="rb_KillYourself" className="add-only" value="Yes" />&nbsp; Yes
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_No5" name="rb_KillYourself" className="add-only" value="No" />&nbsp; No
                  </td>
                  <td className="w-100">
                     <input type="radio" id="rb_Noi5" name="rb_KillYourself" className="add-only" value="No" />&nbsp; Don't Know
                  </td>
               </tr>
               <tr>
                  <td className="w-750">
                     <b> Highest Domain Score (clinician) </b>
                     <input type="text" name="txtHighestDomain59" id="txtHighestDomain59" className="add-only" />
                  </td>
               </tr>
            </table>
            <p>
               <strong>Instructions to Clinicians</strong>
            </p>
            <p>
               The DSM-5 Parent/Guardian-Rated Level 1 Cross-Cutting Symptom Measure-Child Age 6-17 assesses mental health domains that
               are important across psychiatric diagnoses. It is intended to help clinicians identify additional areas of inquiry that may have
               significant impact on the child's treatment and prognosis. The measure may also be used to track changes in the child's symptom
               presentation over time.
            </p>
            <p>
               The measure consists of 25 questions that assess 12 psychiatric domains, including depression, anger, irritability, mania, anxiety,
               somatic symptoms, inattention, suicidal ideation/attempt, psychosis, sleep disturbance, repetitive thoughts and behaviors, and
               substance use. Each item asks the parent or guardian to rate how much (or how often) his or her child has been bothered by the
               specific symptom during the past 2 weeks. The measure was found to be clinically useful and had good test-retest reliability in the
               DSM-5 Field Trials in pediatric clinical samples across the United States.
            </p>
            <p>
               <strong>Scoring and Interpretation</strong>
            </p>
            <p>
               Nineteen of the 25 items on the measure are each rated on a 5 point scale (0 =none or not at all; 1 =slight or rare, less than a day or
               two; 2 =mild or several days; 3-=moderate or more than half the days; and 4 =severe or nearly every day). The suicidal ideation,
               suicide attempt, and substance abuse items are each rated on a "Yes, No, or Don't Know" scale. The score on each item within a
               domain should be reviewed. Because additional inquiry is based on the highest score on any item within a domain, the clinician is
               asked to indicate that score in the "Highest Domain Score" column. Table 1 (below) outlines threshold scores that may be used to
               guide further inquiry for each domain. With the exception of inattention and psychosis, a rating of mild (i.e.,2) or greater on any
               item within a domain that is scored on the 5 point scale may serve as a guide for additional inquiry and follow-up to determine if a
               more detailed assessment for that domain is needed. A parent or guardian's rating of "Don't Know" on the suicidal ideation, suicide
               attempt, and any of the substance use items, especially for a child age 11-17, may be used as a guide for additional inquiry of the
               issues with the child. The DSM-5  Level 2 Cross-Cutting Symptom measures in Table 1 may be used as a resource to provide more
               detailed information on the symptoms associated with some of the Level 1 domains.
            </p>
            <p>
               <strong>Frequency of Use</strong>
            </p>
            <p>
               To track change in the child's symptom presentation over time, the measure may be completed at regular intervals as clinically
               indicated, depending on the stability of the child's symptoms and treatment status, and preferably by the same parent or guardian.
               Consistently high scores on a particular domain may indicate significant and problematic symptoms for the child that might warrant
               further assessment, treatment, and follow-up. Clinical judgment should guide decision making.
            </p>
            <p>
               <strong>Table 1: DSM-5 Parent/Guardian-Rated Level 1-Cross-Cutting Symptom Measure-Child Age 6-17: domains, thresholds for further
                  inquiry, and associated Level 2 measures</strong>
            </p>
            <table>
               <tr>
                  <td className="w-80 text-center">
                     <span className="eleHeader">Domain</span>
                  </td>
                  <td className="w-150 text-center">
                     <span className="eleHeader">Domain Name</span>
                  </td>
                  <td className="w-200 text-center">
                     <span className="eleHeader">Threshold to guide further inquiry</span>
                  </td>
                  <td className="w-320">
                     <span className="eleHeader">DSM-5 Level 2 Cross-Cutting Symptom Measure available online</span>
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     I.
                  </td>
                  <td className="w-150 text-center">
                     Somatic Symptoms
                  </td>
                  <td className="w-200 text-center">
                     Mild or greater
                  </td>
                  <td className="w-320">
                     LEVEL 2-Somatic Symptom-Parent/Guardian of Child Age 6-17 (Patient Health Questionnaire 15 Somatic Symptom Severity (PHQ-15))
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     II.
                  </td>
                  <td className="w-150 text-center">
                     Sleep Problems
                  </td>
                  <td className="w-200 text-center">
                     Mild or greater
                  </td>
                  <td className="w-320">
                     LEVEL 2-Sleep Disturbance-Parent/ Guardian of Child Age 6-17 (PROMIS-
                     Sleep Disturbance-Short Form)
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     III.
                  </td>
                  <td className="w-150 text-center">
                     Inattention
                  </td>
                  <td className="w-200 text-center">
                     Slight or greater
                  </td>
                  <td className="w-320">
                     LEVEL 2-Inattention-Parent/Guardian of Child Age 6-17 (SNAP-IV)
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     IV.
                  </td>
                  <td className="w-150 text-center">
                     Depression
                  </td>
                  <td className="w-200 text-center">
                     Mild or greater
                  </td>
                  <td className="w-320">
                     LEVEL 2-Depression-Parent/Guardian of Child Age 6-17 (PROMIS Emotional
                     Distress-Depression-Parent Item Bank)
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     V.
                  </td>
                  <td className="w-150 text-center">
                     Anger
                  </td>
                  <td className="w-200 text-center">
                     Mild or greater
                  </td>
                  <td className="w-320">
                     LEVEL 2-Anger-Parent/Guardian of Child Age 6-17 (PROMIS Emotional
                     Distress-Calibrated Anger Measure-Parent)
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     VI.
                  </td>
                  <td className="w-150 text-center">
                     Irritability
                  </td>
                  <td className="w-200 text-center">
                     Mild or greater
                  </td>
                  <td className="w-320">
                     LEVEL 2-Irritability-Parent/Guardian of Child Age 6-17 (Affective Reactivity
                     Index)
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     VII.
                  </td>
                  <td className="w-150 text-center">
                     Mania
                  </td>
                  <td className="w-200 text-center">
                     Mild or greater
                  </td>
                  <td className="w-320">
                     LEVEL 2-Mania-Parent/Guardian of Child Age 6-17 (adapted from the Altman
                     Self-Rating Mania Scale)
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     VIII.
                  </td>
                  <td className="w-150 text-center">
                     Anxiety
                  </td>
                  <td className="w-200 text-center">
                     Mild or greater
                  </td>
                  <td className="w-320">
                     LEVEL 2-Anxiety-Parent/Guardian of Child Age 6-17 (adapted from PROMIS
                     Emotional Distress-Anxiety-Parent Item Bank)
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     IX.
                  </td>
                  <td className="w-150 text-center">
                     Psychosis
                  </td>
                  <td className="w-200 text-center">
                     Slight or greater
                  </td>
                  <td className="w-320">
                     None
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     X.
                  </td>
                  <td className="w-150 text-center">
                     Repetitive Thoughts and Behaviors
                  </td>
                  <td className="w-200 text-center">
                     Mild or greater
                  </td>
                  <td className="w-320">
                     None
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     XI.
                  </td>
                  <td className="w-150 text-center">
                     Substance Use
                  </td>
                  <td className="w-200 text-center">
                     Yes/Don't Know
                  </td>
                  <td className="w-320">
                     LEVEL 2 -Substance Use-Parent/Guardian of Child Age 6-17 (adapted from the
                     NIDA-modified ASSIST)/LEVEL 2 -Substance Use-Child Age 11-17 (adapted
                     from the NIDA-modified ASSIST)
                  </td>
               </tr>
               <tr>
                  <td className="w-80 text-center">
                     XII.
                  </td>
                  <td className="w-150 text-center">
                     Suicidal Ideation/Suicide Attempts
                  </td>
                  <td className="w-200 text-center">
                     Yes/Don't Know
                  </td>
                  <td className="w-320">
                     None
                  </td>
               </tr>
            </table>
            <p>
               Not validated for children by the PROMIS group but found to have acceptable test-retest reliability with parent informants in the DSM-5 Field Trial.
            </p>
         </div>
      </form>
   )
}